export default `float i,g,e,s=1.,l;
    vec3 q=p;
    for(int j=0;j++<4;)
      p=mod(p-1.,2.)-1.,
      l=2./dot(p,p),
      p*=l, s*=l;
    return length(p.xy)/s;
  }`